module.exports = "/fonts/vendor/dropify/dist/dropify.eot?4e8b017aef78cc114006cba896850fbd";